import { render, staticRenderFns } from "./TabCargarArchivos.vue?vue&type=template&id=3282e012&scoped=true"
import script from "./TabCargarArchivos.vue?vue&type=script&lang=js"
export * from "./TabCargarArchivos.vue?vue&type=script&lang=js"
import style0 from "./TabCargarArchivos.vue?vue&type=style&index=0&id=3282e012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282e012",
  null
  
)

export default component.exports